import Vue from 'vue';
import Vuetify from 'vuetify/lib';

// import en from "vuetify/src/locale/en";
import da from "../i18n/vuetify/da";

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    dark: true,
  },
  icons: {
    iconfont: 'mdi',
  },
  lang: {
    locales: { da },
    current: 'da',
  },
  options: {
    customProperties: true,
  },
});
